<template>
  <div>
    <ifac-page-size-select
      v-show="rowData.length > 0"
      v-model="pageSizeChoice"
      :allow-all="allowAll"
      @change="onPageSizeChanged"
    />
    <ag-grid-vue
      class="ag-theme-alpine"
      :pagination="true"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      :rowData="rowData"
      :gridOptions="gridOptions"
      :paginationPageSize="paginationPageSize"
      @gridReady="onGridReady"
      @cellClicked="onCellClicked"
      rowSelection="single"
      domLayout="autoHeight"
    ></ag-grid-vue>
  </div>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue';
import GridMixin from '@/views/components/grids/GridMixin';
import {
  gridColumns,
  gridDefaultColDef,
} from '@/views/components/grids/awards/NominationReportsGrid';
import Nominations from '@/services/Api/Awards/Nominations';

export default {
  name: 'DecisionsNominationsTable',
  components: {
    AgGridVue,
  },
  mixins: [GridMixin],
  props: {
    award: [Object, null],
    reports: Array,
  },
  data() {
    return {
      defaultColDef: gridDefaultColDef,
      columnDefs: gridColumns,
      rowData: [],
    };
  },
  created() {
    this.fetchNominations();
  },
  methods: {
    fetchNominations() {
      if (!this.award) {
        return;
      }

      const params = {
        award_id: this.award?.id,
      };

      Nominations.all(params).then((response) => {
        this.rowData = response.data.data;
      });
    },
    onCellClicked({ data }) {
      if (!data.reports[0]?.id) {
        return;
      }

      this.$router.push({
        name: 'ReportsEdit',
        params: {
          report: data.reports[0].id,
        },
      });
    },
  },
  watch: {
    award() {
      this.fetchNominations();
    },
  },
};
</script>
